var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
/**
 * API services for Rich Content Template resources
 */
import api from '@utils/axios';
/**
 * Fetches all rich content resources from the API
 * @returns Promise with array of rich content resources
 */
export function getRichContentResources() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/rich_content_resources');
            return response.data;
        }
        catch (error) {
            console.error('Error fetching rich content resources:', error);
            throw error;
        }
    });
}
/**
 * Updates a rich content resource
 * @param id - The resource ID
 * @param type - The resource type (Summary, ScopeOfWork, Exclusion, TermsAndCondition)
 * @param body - The new body content
 * @returns Promise with the updated resource
 */
export function updateRichContentResource(id, type, body) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/rich_content_resources/${id}?type=${type}`, {
                rich_content_resource: { text: body }
            });
            return response.data;
        }
        catch (error) {
            console.error('Error updating rich content resource:', error);
            throw error;
        }
    });
}
